import React, { useState, useCallback, useEffect } from "react";
import {
  Grid,
  Card,
  CardContent,
  Typography,
  Button,
  IconButton,
} from "@mui/material";
import { Close, Assignment, Group, Warning, Star } from "@mui/icons-material";
import homeApi from "../../services/home";
import { useDispatch, useSelector } from "react-redux";
import { showLoader, hideLoader } from "../../redux/loader/actions";
import CustomDatagrid from "../../components/datagrid";
import { getDecryptedCookie } from "../../utils";
import getAllatestofferApi from "../../services/offer";
import moment from "moment";

const Dashboard = () => {
  const dispatch = useDispatch();
  const organizationItems = useSelector(
    (state) => state.organizationReducer.items
  );
  const [showBanner, setShowBanner] = useState(true);
  const [roleActivityList, setRoleActivityList] = useState([]);
  const [roleRowCount, setRoleRowCount] = useState();
  const [latestoffer, setLatestOffer] = useState();
  const [offer, setOffer] = useState(null);
  const [rolePaginationModel, setRolePaginationModel] = useState({
    page: 0,
    pageSize: 3,
  });
  const [expiryList, setExpiryList] = useState([]);
  const [expiryRowCount, setExpiryRowCount] = useState();
  const [expiryPaginationModel, setExpiryPaginationModel] = useState({
    page: 0,
    pageSize: 3,
  });
  const [activeSubscriptionList, setActiveSubscriptionList] = useState([]);
  const [activeRowCount, setActiveRowCount] = useState();
  const [activePaginationModel, setActivePaginationModel] = useState({
    page: 0,
    pageSize: 3,
  });
  const userName = getDecryptedCookie("fdf");
  const uuids = getDecryptedCookie("ids");
  const uuid = getDecryptedCookie("uuid");

  const getAllActiveSubscription = (activePaginationModel) => {
    const status = "active";
    dispatch(showLoader());
    const onSuccess = (res) => {
      dispatch(hideLoader());
      setActiveSubscriptionList(res?.data?.data?.data || []);
      setActiveRowCount(res?.data?.data?.pagination?.totalItems || 0);
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      console.error("Error fetching active subscriptions", err);
    };

    homeApi
      .getActiveSubscription(
        uuid,
        activePaginationModel.page,
        activePaginationModel.pageSize,
        status
      )
      .then(onSuccess)
      .catch(onFailure);
  };

  const getAllExpireSubscription = (paginationModel) => {
    const status = "expiring";
    dispatch(showLoader());
    const onSuccess = (res) => {
      dispatch(hideLoader());
      setExpiryList(res?.data?.data?.data || []);
      setExpiryRowCount(res?.data?.data?.pagination?.totalItems || 0);
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
      console.error("Error fetching active subscriptions", err);
    };

    homeApi
      .getActiveSubscription(
        uuid,
        paginationModel.page,
        paginationModel.pageSize,
        status
      )
      .then(onSuccess)
      .catch(onFailure);
  };

  useEffect(() => {
    if (uuid) {
      getAllActiveSubscription(activePaginationModel);
    }
  }, [activePaginationModel, userName]);
  useEffect(() => {
    if (uuid) {
      getAllExpireSubscription(expiryPaginationModel);
    }
  }, [expiryPaginationModel, userName]);

  const getAllRoleActivity = (rolePaginationModel) => {
    dispatch(showLoader());
    const onSuccess = (res) => {
      dispatch(hideLoader());
      setRoleActivityList(res?.data?.data || []);
      setRoleRowCount(res?.data?.pagination?.totalItems || 0);
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
    };

    homeApi
      .getRoleActivity(
        uuid,
        rolePaginationModel.page,
        rolePaginationModel.pageSize
      )
      .then(onSuccess)
      .catch(onFailure);
  };

  useEffect(() => {
    if (uuid) {
      getAllRoleActivity(rolePaginationModel);
    }
  }, [rolePaginationModel, userName]);

  const getOfferdata = useCallback(() => {
    dispatch(showLoader());

    const onSuccess = (res) => {
      dispatch(hideLoader());

      if (res?.data?.data) {
        const latestOffer = Array.isArray(res.data.data)
          ? res.data.data[0]
          : res.data.data;

        setLatestOffer(latestOffer);
      }
    };

    const onFailure = (err) => {
      dispatch(hideLoader());
    };

    getAllatestofferApi.getSpecificOffer().then(onSuccess).catch(onFailure);
  }, [dispatch]);

  useEffect(() => {
    getOfferdata();
  }, [getOfferdata, organizationItems]);

  const formattedDate = latestoffer?.valid_to
    ? new Date(latestoffer.valid_to).toLocaleDateString("en-GB")
    : "";

  const getDiscountSymbol = (type) => {
    if (type === "rupee") {
      return "₹";
    } else if (type === "percentage") {
      return "%";
    }
    return "";
  };

  const roleColumns = [
    {
      field: "user",
      headerName: "User",
      width: 200,
      headerAlign: "left",
      align: "left",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const capitalizedUserType = params.row.user
          ? params.row.user?.charAt(0).toUpperCase() + params.row.user.slice(1)
          : "";
        return capitalizedUserType;
      },
    },
    {
      field: "role",
      headerName: "Role",
      width: 200,
      headerAlign: "left",
      align: "left",
      sortable: false,
      filterable: false,
      renderCell: (params) => {
        const capitalizedUserType = params.row.role
          ? params.row.role?.charAt(0).toUpperCase() + params.row.role.slice(1)
          : "";
        return capitalizedUserType;
      },
    },
    {
      field: "recent_activity",
      headerName: "Recent Activity",
      width: 150,
      headerAlign: "left",
      align: "left",
      sortable: false,
      filterable: false,
    },
  ];
  const roleRows = Array.isArray(roleActivityList)
    ? roleActivityList.map((data, index) => ({
        id: index + 1,
        user: data.username,
        role: data?.roleMappings[0]?.role?.role
          ? data?.roleMappings[0]?.role?.role
          : "-",
        recent_activity: new Date(data.modified_at).toLocaleDateString("en-GB"),
      }))
    : [];

  const activeColumn = [
    {
      field: "product_name",
      headerName: "Product Name",
      width: 140,
      headerAlign: "left",
      align: "left",
      sortable: false,
      filterable: false,
    },
    {
      field: "subscription_id",
      headerName: "Business Subscription ID",
      width: 140,
      headerAlign: "left",
      align: "left",
      sortable: false,
      filterable: false,
    },
    {
      field: "bussiness_name",
      headerName: "Bussiness Name",
      width: 150,
      headerAlign: "left",
      align: "left",
      sortable: false,
      filterable: false,
    },
    {
      field: "plan",
      headerName: "Plan",
      width: 140,
      headerAlign: "left",
      align: "left",
      sortable: false,
      filterable: false,
    },
    {
      field: "subscriptionType",
      headerName: "Subscription Type",
      width: 140,
      headerAlign: "left",
      align: "left",
      sortable: false,
      filterable: false,
    },
  ];

  const activeRows = Array.isArray(activeSubscriptionList)
    ? activeSubscriptionList.map((data, index) => ({
        id: index + 1,
        product_name: data.productPlanDetails?.product?.name,
        subscription_id: data?.businessDetailsFromSubscription?.business_code,
        bussiness_name: data?.businessDetailsFromSubscription?.business_name,
        plan: data.productPlanDetails?.product_plan_name,
        subscriptionType:
          data?.subscription_type.charAt(0).toUpperCase() +
          data?.subscription_type.slice(1),
      }))
    : [];

  const expiryColumn = [
    {
      field: "product_name",
      headerName: "Product Name",
      width: 140,
      headerAlign: "left",
      align: "left",
      sortable: false,
      filterable: false,
    },
    {
      field: "subscription_id",
      headerName: "Business Subscription ID",
      width: 140,
      headerAlign: "left",
      align: "left",
      sortable: false,
      filterable: false,
    },
    {
      field: "bussiness_name",
      headerName: "Bussiness Name",
      width: 150,
      headerAlign: "left",
      align: "left",
      sortable: false,
      filterable: false,
    },
    {
      field: "expiry",
      headerName: "Expiry",
      width: 140,
      headerAlign: "left",
      align: "left",
      sortable: false,
      filterable: false,
    },
  ];
  const expiryRows = Array.isArray(expiryList)
    ? expiryList.map((data, index) => ({
        id: index + 1,
        product_name: data.productPlanDetails?.product?.name,
        subscription_id: data?.businessDetailsFromSubscription?.business_code,
        bussiness_name: data?.businessDetailsFromSubscription?.business_name,
        expiry: moment.utc(data.expiry_date).endOf("day").format("DD-MM-YYYY"),
      }))
    : [];

  return (
    <Grid container spacing={3} sx={{ padding: "20px" }}>
      <Grid item xs={12}>
        <Typography
          variant="h6"
          sx={{
            fontWeight: "bold",
            color: "#333",
            marginBottom: "3px",
          }}
        >
          Welcome, {userName?.charAt(0)?.toUpperCase() + userName?.slice(1)}!
        </Typography>
      </Grid>
     

      {showBanner && latestoffer && (
        <Grid item xs={12}>
          <Card
            sx={{
              borderRadius: "15px",
              boxShadow: "0 4px 8px rgba(0,0,0,0.1)",
              background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
              color: "#ffffff",
              padding: "12px",
              paddingBottom: "18px",
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              position: "relative",
              fontSize: "14px",
              fontWeight: "bold",
              maxHeight: "100px",
              overflow: "hidden",
            }}
          >
            <CardContent sx={{ padding: "0px", width: "100%" }}>
              <Typography
                sx={{
                  display: "block",
                  margin: "0",
                  color: "#ffffff",
                  marginTop: "10px",
                  textAlign: "center",
                }}
                variant="h6"
              >
                🚀 Grab {getDiscountSymbol(latestoffer.offer_discount_type)}
                {latestoffer.offer_discount} OFF on our{" "}
                {latestoffer.productDetails.name}!{" "}
                {`Use code ${latestoffer.offer_code} before `} {formattedDate}{" "}
                to save big!🚀
              </Typography>
            </CardContent>

            <IconButton
              sx={{
                position: "absolute",
                top: "6px",
                right: "8px",
                color: "#fff",
              }}
              onClick={() => setShowBanner(false)}
            >
              <Close />
            </IconButton>
          </Card>
        </Grid>
      )}

      <Grid item xs={12} md={6}>
        <Card
          sx={{
            position: "relative",
            borderRadius: "6px 0px 0p 6px",
            boxShadow: "0 6px 12px rgba(0,0,0,0.1)",
            background: "#ffffff",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: "0",
              left: "0",
              width: "5px",
              height: "100%",
              background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
              borderRadius: "5px 0 0 5px",
              zIndex: "1",
            },
            "& > *": {
              position: "relative",
              zIndex: "2",
            },
          }}
        >
          <CardContent
            sx={{
              display: "flex",
              flexDirection: "column",
              alignItems: "center",
              textAlign: "center",
              padding: "24px",
            }}
          >
            <img
              src="https://tagitstore-s3b01.s3.ap-south-1.amazonaws.com/product/75000tagitstore/live/17388327685333b43u7a2m6t44v11PBA.a4ea79d9e121e9b35ca0%20%281%29.png"
              style={{ width: "150px", color: "#000", marginBottom: "16px" }}
            />
            <Typography
              variant="h5"
              gutterBottom
              sx={{ color: "#000", marginBottom: "16px" }}
            >
              Pawn Broker Automation
            </Typography>
            <Typography
              variant="body1"
              sx={{ color: "#000", marginBottom: "24px" }}
            >
              Our cloud-based pawn broker automation system offers a fully
              digital solution, replacing manual processes with advanced
              features.
            </Typography>
          </CardContent>
        </Card>
      </Grid>

      <Grid item xs={12} md={6}>
        <Card
          sx={{
            position: "relative",
            borderRadius: "6px 0px 0p 6px",
            boxShadow: "0 6px 12px rgba(0,0,0,0.1)",
            background: "#ffffff",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: "0",
              left: "0",
              width: "5px",
              height: "100%",
              background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
              borderRadius: "5px 0 0 5px",
              zIndex: "1",
            },
            "& > *": {
              position: "relative",
              zIndex: "2",
            },
          }}
        >
          <CardContent>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              <Assignment /> Active/Subscribed Products
            </Typography>

            {activeRows.length === 0 ? (
              <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
                {" "}
                No Data Found
              </Typography>
            ) : (
              <CustomDatagrid
                columns={activeColumn}
                rows={activeRows}
                paginationModel={activePaginationModel}
                onPaginationModelChange={setActivePaginationModel}
                rowCount={activeRowCount}
                disableSelectionOnClick={true}
                checkboxSelection={false}
              />
            )}
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card
          sx={{
            position: "relative",
            borderRadius: "6px 0px 0p 6px",
            boxShadow: "0 6px 12px rgba(0,0,0,0.1)",
            background: "#ffffff",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: "0",
              left: "0",
              width: "5px",
              height: "100%",
              background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
              borderRadius: "5px 0 0 5px",
              zIndex: "1",
            },
            "& > *": {
              position: "relative",
              zIndex: "2",
            },
          }}
        >
          <CardContent>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              <Group /> User and Role Management
            </Typography>

            {roleRows.length === 0 ? (
              <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
                {" "}
                No Data Found
              </Typography>
            ) : (
              <CustomDatagrid
                columns={roleColumns}
                rows={roleRows}
                paginationModel={rolePaginationModel}
                onPaginationModelChange={setRolePaginationModel}
                rowCount={roleRowCount}
                disableSelectionOnClick={true}
                checkboxSelection={false}
              />
            )}
          </CardContent>
        </Card>
      </Grid>
      <Grid item xs={12} md={6}>
        <Card
          sx={{
            position: "relative",
            borderRadius: "6px 0px 0p 6px",
            boxShadow: "0 6px 12px rgba(0,0,0,0.1)",
            background: "#ffffff",
            overflow: "hidden",
            "&::before": {
              content: '""',
              position: "absolute",
              top: "0",
              left: "0",
              width: "5px",
              height: "100%",
              background: "linear-gradient(45deg, #ff4b2b 30%, #ff416c 90%)",
              borderRadius: "5px 0 0 5px",
              zIndex: "1",
            },
            "& > *": {
              position: "relative",
              zIndex: "2",
            },
          }}
        >
          <CardContent>
            <Typography
              variant="h6"
              gutterBottom
              sx={{ display: "flex", alignItems: "center", gap: "8px" }}
            >
              <Warning /> About to Expiry/Expired Products
            </Typography>

            {expiryRows.length === 0 ? (
              <Typography variant="subtitle1" sx={{ textAlign: "center" }}>
                {" "}
                No Data Found
              </Typography>
            ) : (
              <CustomDatagrid
                columns={expiryColumn}
                rows={expiryRows}
                paginationModel={expiryPaginationModel}
                onPaginationModelChange={(newModel) => {
                  setExpiryPaginationModel(newModel);
                }}
                rowCount={expiryRowCount}
                disableSelectionOnClick={true}
                checkboxSelection={false}
              />
            )}
          </CardContent>
        </Card>
      </Grid>
    </Grid>
  );
};

export default Dashboard;
